import { FirestoreProductSubtitleCandidate } from "reedy-data/models";
import { SubtitleListItem } from "./subtitle-list-item";

export interface SubtitlesListProps {
  subtitles: FirestoreProductSubtitleCandidate[] | undefined;
  onCopy: (subtitle: FirestoreProductSubtitleCandidate, index: number) => void;
  testId?: string;
}

export const SubtitlesList = ({
  subtitles,
  onCopy,
  testId,
}: SubtitlesListProps) => {
  return (
    <div
      className="flex flex-col gap-y-2 mt-[13px]"
      data-testid={testId ?? "subtitles-list"}
    >
      {subtitles?.map((subtitle, index) => (
        <SubtitleListItem
          // biome-ignore lint/suspicious/noArrayIndexKey: subtitles can repeat, so the index keeps keys unique
          key={`${subtitle.subtitle}-${index}`}
          subtitle={subtitle}
          index={index}
          onCopy={onCopy}
          testId={`subtitle-list-item-${index}`}
        />
      ))}
    </div>
  );
};
